import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateCreateDraftTaskSearch } from '../-publicSearch';

// This route handles redirects for backwards compatibility purposes
export const Route = createFileRoute('/tasks/new')({
  beforeLoad: ({ search }) => {
    throw redirect({
      search,
      to: '/app/draft-task/create',
    });
  },
  component: () => <div />,
  validateSearch: validateCreateDraftTaskSearch,
});
